// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__l6dZX","col":"styles_col__3ZX4Y"};